import { useGate } from 'effector-react'

import { GeolocationControllerGate } from '../model/current'

export function GeolocationController() {
  useGate(GeolocationControllerGate)

  return null
}
